import { render } from "./DigilamFlatbedDieCutter.vue?vue&type=template&id=276bbb66&scoped=true"
const script = {}

import "./DigilamFlatbedDieCutter.vue?vue&type=style&index=0&id=276bbb66&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276bbb66"]])

export default __exports__